var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menus'),_c('roles_table',{attrs:{"company_uid":_vm.company_uid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }